import React, { useState } from 'react'
import { Button, Col, FloatingLabel, Form, FormControl, Modal, Row } from 'react-bootstrap'
import { GetUsersByUserGroupOutput } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels';
import { CreateAppointmentInput, CreateUserAppointmentInput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/createAppointmentModels';
import moment from 'moment';
import { createRestrictedAppointmentDates, createUserAppointment } from '../../../../Adaptor/TUBSIS';
import AppointmentCreateWithNotExistUser from './AppointmentCreateWithNotExistUser';
import AppointmentCreateWithExistUser from './AppointmentCreateWithExistUser';
import { GetRestrictedAppointmentDatesOutput } from '../../../../Adaptor/TUBSIS/controllers/RestrictedAppointmentDates/models/getRestrictedAppointmentDates';

type Props = {}

const RestrictedAppointmentDatesCreate = () => {

    const [showModal, setShowModal] = useState(false);
    
    const clearForm = () => {
        setDescription(null)
        setStartDate(null)
        setEndDate(null)
    }

    const openModal = () => {
        clearForm()
        setShowModal(true);
    };

    const closeModal = () => {
        clearForm()
        setShowModal(false);
        // window.location.reload();
    };
   
    const [description, setDescription] = useState<string | null>(null);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const parseDateStringToDate = (dateString: string): Date | null => {
        // Tarih stringinin uygun formatta olup olmadığını kontrol et
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) return null;
    
        // Yıl, ay ve gün bilgilerini al
        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1; // JavaScript'te aylar 0'dan başlar, bu yüzden 1 çıkarıyoruz.
        const day = parseInt(match[3]);
    
        if (month < 0 || month > 11 || day < 1 || day > 31) return null;
    
        const parsedDate = new Date(year, month, day);
        
        // Oluşturulan tarihin geçerli olup olmadığını kontrol et
        const currentDate = new Date();
        if (parsedDate <= currentDate) return null;
    
        return parsedDate;
    };

    const [isValidStartDate, setIsValidStartDate] = useState<boolean>(true);
    const [isValidEndDate, setIsValidEndDate] = useState<boolean>(true);

    const handleItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === 'startDate') {
            const parsedDate = parseDateStringToDate(value)
            setStartDate(parsedDate);
            setIsValidStartDate(parsedDate !== null);
        } else if (name === 'endDate') {
            const parsedDate = parseDateStringToDate(value)
            setEndDate(parsedDate);
            setIsValidEndDate(parsedDate !== null);
        } 
        else if (name === 'description') {
            setDescription(value??"");
        } 
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => {
        e.preventDefault();

        if (!isValidStartDate || !isValidStartDate || startDate === null || endDate === null || endDate <= startDate) {
            alert("Hatalı bir kısıtlama tarihi girdiniz. Lütfen uygun bir giriş yapınız.")
            return;
        }

        let parsedStartDate = new Date(startDate)
        let parsedEndDate = new Date(endDate)

        parsedStartDate.setHours(parsedStartDate.getHours() + 3)//utc kaynaklı düzeltme
        parsedEndDate.setHours(parsedEndDate.getHours() + 3)

        const requestModel = {
            startDate: new Date(parsedStartDate),
            endDate: new Date(parsedEndDate),
            descriptions: description??""
        };

        const response = await createRestrictedAppointmentDates(requestModel);

        if (response.success){
            alert(response.message); 
            window.location.reload();
        } else {
            alert(response.message);
            return;
        }

        closeModal(); // Modalı kapat
    };

    return (
      //<div>AppointmentCreateWithUser</div>
        <div className='text-end mt-2' >
            <input type='button' className='btn btn-primary' value={"OLUŞTUR"} onClick={openModal} />
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Randevu Tarihi Kısıtla</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>    
                        <Row className="mb-3">
                            <Form.Group as={Col}>
                                <FloatingLabel controlId="startDate" label="Başlangıç Tarihi">
                                    <FormControl 
                                        type="date" 
                                        name="startDate"
                                        isInvalid={!isValidStartDate}
                                        onChange={handleItemChange} />
                                    <Form.Control.Feedback type="invalid">
                                        Geçerli bir tarih girin.
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Form.Group>

                            <Form.Group as={Col}>
                                <FloatingLabel controlId="endDate" label="Bitiş Tarihi">
                                    <FormControl 
                                        type="date" 
                                        name="endDate" 
                                        isInvalid={!isValidEndDate}
                                        onChange={handleItemChange} />
                                    <Form.Control.Feedback type="invalid">
                                        Geçerli bir tarih girin.
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col}>
                                <FloatingLabel controlId="description" label="Açıklama">
                                    <FormControl 
                                        type="text" 
                                        name="description" 
                                        onChange={handleItemChange} />
                                </FloatingLabel>
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Kapat
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Kaydet
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default (RestrictedAppointmentDatesCreate)